import React from "react";
import { kebabCase } from '../../../../utils/kebabCase';

interface BadgesProps {
  badges: string[];
}

export function Badges({ badges }: BadgesProps): JSX.Element | null {
  return <>
    {
      badges.map((tag: string ) => {
        if (tag.includes("custom-badge:")) {
          const tagSplit = tag.split(":");
          return <span className={`badge custom-badge-${tagSplit[1]}`}>{tagSplit[2]}</span>;
        } else if (tag.includes("badge:") && tag.includes("buy")) {
          const tagSplit = tag.split(":");
          return (
            <span className={`badge mint promo-buy promo-${kebabCase(tag)}`}>{`Buy ${tagSplit[2]}, get ${tagSplit[3]}% off`}</span>
          );
        } else if (tag.includes("badge:") && tag.includes("bogof")) {
          return <span className="badge promo-bygof watermelon">buy one get one free</span>;
        } else if (tag.includes("store-only")) {
          return <span className="badge in-store-only">in store only</span>;
        } else {
          return null;
        }
      })
    }
  </>
};